<template>
  <div class="bgClass">
    <div class="loginClass">
      <div class="logo">加入會員</div>
      <div style="width: 100%; margin-top: 1%"></div>
      <div class="content">成為NuMatch會員，獲取更多健康資訊</div>
      <div style="width: 100%; margin-top: 1%"></div>
      <!-- google登录，先隐藏 -->
      <div class="loginGoogle" style="display: none"></div>
      <div style="width: 100%; margin-top: 1%"></div>
      <el-form
        :rules="rules"
        label-position="top"
        ref="formRef"
        :model="dynamicValidateForm"
        label-width="120px"
        class="dynamic"
      >
        <el-form-item prop="name" :id="nameId">
          <el-input
            id="name"
            v-model="dynamicValidateForm.name"
            placeholder="姓名/暱稱"
            @focus="onFocuss('name')"
            @blur="onBlurs('name')"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="email" :id="mailId">
          <el-input ref="focusInput" id="mail" @focus="onFocuss('mail')" @blur="onBlurs('mail')" v-model="dynamicValidateForm.email" placeholder="電郵">
            <template #suffix v-if="dynamicValidateForm.email == '' && focusBool == false">
              <div class="inputName" @click="beginFocus">可作為會員登入之憑證，請真實填寫</div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex">
            <div
              class="selected"
              @click="
                dynamicValidateForm.show =
                  dynamicValidateForm.show == '1' ? '0' : '1'
              "
            >
              <div :class="dynamicValidateForm.show == '1' ? 'sImg' : 'nImg'">
                <div class="litteRound"></div>
              </div>
            </div>
            <div class="showContent">
              本人確認及同意<a
                target="_blank"
                href="https://www.numatch.com.hk/oae/#/agreement"
                >條款與細則</a
              >、<a
                target="_blank"
                href="https://www.numatch.com.hk/oae/#/agreement"
                >私隱政策聲明</a
              >及<a 
                target="_blank"
                href="https://www.numatch.com.hk/oae/#/agreement">個人資料收集聲明</a>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            id="otherBtn"
            round
            color="#6B834B"
            size="large"
            @click="submitForm"
            >創建NuMatch會員帳號</el-button
          >
        </el-form-item>
      </el-form>
      <div class="login" @click="pushlogin">
        已有帳號？<span>點此登入</span>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Bottom from "../components/bottom/bottom.vue";
import { registers } from "../api/index";
export default {
  name: "App",
  components: {
    Bottom,
  },
  setup() {
    const userRouter = useRouter();
    onMounted(() => {});

    const formRef = ref(null);
    const dynamicValidateForm = ref({
      name: "",
      email: "",
      show: "0",
    });
    const pushRegister = () => {
      userRouter.push({
        path: "/register",
        query: {},
      });
    };
    const pushlogin = () => {
      userRouter.push({
        path: "/login",
        query: {},
      });
    };

    const validateMail = (rule, value, callback) => {
      if (value === "") {
        return true;
      } else {
        // eslint-disable-next-line no-useless-escape
        if (/^[\w\.-]+@[a-z0-9\-]+(\.[a-z]{2,6}){1,3}$/i.test(value) === false) {
          callback(new Error("請輸入正確電郵"));
        } else {
          return true;
        }
      }
    };
    const rules = {
      email: [{ required: true, validator: validateMail, trigger: "blur" }],
    };
    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (dynamicValidateForm.value.show == "0") {
            ElMessage.error("請先同意用戶條款");
            return;
          }
          if (dynamicValidateForm.value.email == "") {
            ElMessage.error("請輸入正確電郵");
            return;
          }
          if (dynamicValidateForm.value.name == "") {
            ElMessage.error("請輸入姓名/暱稱");
            return;
          }
          let params = {
            "Accept-Language": "zh-HK",
            platform: "gateway",
            nickname: dynamicValidateForm.value.name,
            account: dynamicValidateForm.value.email,
          };
          registers(params).then((res) => {
            if (res.errCode === 200) {
              ElMessage.success("注册成功");
              userRouter.push({
                path: "/emailMessage",
                query: {},
              });
            } else {
              ElMessage.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    };
    const focusBool = ref(false)
    const onFocuss = (event) => {
      if (event == 'mail') {
        focusBool.value = true
        mailId.value = 'form-mails'
      }else{
        nameId.value = 'form-names'
      }
    };
    const onBlurs = (event) => {
      if (event == 'mail') {
        focusBool.value = false
        mailId.value = 'form-mail'
      }else {
        nameId.value = 'form-name'
      }
    };
    const focusInput = ref(null)
    const beginFocus = () =>{
      focusInput.value.focus()
    };
    const nameId = ref('form-name')
    const mailId = ref('form-mail')

    return {
      mailId,
      nameId,
      focusInput,
      beginFocus,
      focusBool,
      onBlurs,
      onFocuss,
      submitForm,
      rules,
      pushlogin,
      userRouter,
      pushRegister,
      formRef,
      dynamicValidateForm,
    };
  },
};
</script>

<style lang="less" scoped>
.bgClass {
  width: 100%;
  height: 100%;
  min-height: 700px;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
}
.loginClass {
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.logo {
  font-size: 57px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
.content {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
}
.loginGoogle {
  width: calc(100% / 1080 * 259);
  aspect-ratio: 259 / 27;
  background: #0d5bba;
  border-radius: 5px;
}
.dynamic {
  width: calc(100% / 1080 * 259);
}
.logoTitle {
  font-size: 32px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 42px;
}
.content_sub {
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 16px;
}
:deep(.el-input) {
  width: 100%;
  aspect-ratio: 259 / 32 !important;
  --el-input-focus-border-color: rgba(0,0,0,0);
  --el-input-hover-border-color: rgba(0,0,0,0);
  --el-input-clear-hover-color:rgba(0,0,0,0);
}

#otherBtn {
  width: 470px;
  height: 65px;
  border-radius: 33px !important;
}
.inputName {
  font-size: 7px;
  font-family: MicrosoftYaHeiLight;
  color: #999999;
  line-height: 16px;
}

:deep(.el-input__inner::placeholder) {
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 14px;
}

:deep(.el-input-group__suffix) {
  background-color: white !important;
  box-shadow: none;
  border: 1px solid #cdcdcd;
  border-right: 0px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #cdcdcd;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
:deep(.el-radio__label) {
  display: none;
}
.selected {
  width: 40px;
  height: 30px;
  display: flex;
  justify-content: center;
  margin-left: -13px;
  .nImg {
    width: 14px;
    height: 14px;
    border: 1px solid #cdcdcd;
    background: white;
    border-radius: 7.5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sImg {
    width: 14px;
    height: 14px;
    border: 1px solid #6b834b;
    background: #6b834b;
    border-radius: 7.5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .litteRound {
    width: 4px;
    height: 4px;
    background: white;
    border-radius: 2px;
  }
}
.showContent {
  flex-grow: 1;
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 15px;
  text-align: left;
  a {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #333333;
    line-height: 15px;
  }
}
#form-mails{
    :deep(.el-input__wrapper){
      border: 1px solid #6B834B;
    }
}
#form-mail{
  :deep(.el-input__wrapper){
    border: 1px solid #cdcdcd;
  }
}
#form-names{
    :deep(.el-input__wrapper){
      border: 1px solid #6B834B;
    }
}
#form-name{
  :deep(.el-input__wrapper){
    border: 1px solid #cdcdcd;
  }
}
.login {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #333333;
  span {
    color: #6b834b;
    text-decoration: underline;
    cursor: pointer;
    cursor: hand;
  }
}
</style>